import { memo, type ReactElement } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import PlusIcon from '../../../../../shared/components/ui/icons/PlusIcon'
import {
  customerAddProxy
} from '../../../../../shared/components/CustomerAddSlideOver/customerAddProxy'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../shared/utils/gtmUtils'

const handleAddCustomerClick = (): void => {
  customerAddProxy.displaySlideOver = true
  gtmTrackButtonPress(GtagEvents.CUSTOMER_MODAL_OPEN)
}
function AddCustomerButton (): ReactElement {
  const { siteTheme } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      onClick={handleAddCustomerClick}
      className={cn(
        siteTheme.buttonColors.classes,
        'rounded py-2 px-4 text-white flex cursor-pointer'
      )}
    >
      <div className="flex justify-center items-center">
        <PlusIcon additionalClasses="mr-3" />
        <div className="font-semibold">Add Customer</div>
      </div>
    </button>
  )
}

export default memo(AddCustomerButton)
